import { render } from "./MessageSigningPanel.vue?vue&type=template&id=05a0e793"
import script from "./MessageSigningPanel.vue?vue&type=script&lang=js"
export * from "./MessageSigningPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__